import { Box, Typography } from "@material-ui/core";
import orange from "@material-ui/core/colors/orange";
import React from "react";
import { mainContentColor } from '../../components/lib/Color';

type Props = {
    position: 1 | 2 | 3,
    label: React.ReactElement
}

const AssetPositionAreaRow = ({ position, label }: Props) => {
    return (
        <>
            <Box style={{
                position: "absolute",
                background: orange[500],
                borderRadius: "100%",
                width: 40
            }}>
                <Typography variant="h6" style={{ color: "white", margin: "3px" }}>
                    {position}
                </Typography>
            </Box>
            <Box style={{
                marginTop: 10,
                background: mainContentColor,
                minHeight: 50
            }}>
                {label}
            </Box>
        </>

    );
}

export default AssetPositionAreaRow;